import { Injectable } from '@angular/core';
import { CanMatch, Route, UrlSegment } from '@angular/router';
import { AuthenticatedProfileId } from 'src/core/context/execution-context.types';
import { ExecutionContextService } from 'src/core/context/execution-context.service';

/**
 * Selecciona una implementación de ruta sin exponer el perfil en la URL.
 *
 * El guard no interpreta ROL, CARGO ni flags legacy. Esos valores ya fueron
 * normalizados por ExecutionContextService en el borde de autenticación.
 */
@Injectable({ providedIn: 'root' })
export class ProfileRouteMatchGuard implements CanMatch {
  constructor(private readonly executionContext: ExecutionContextService) {}

  canMatch(route: Route, _segments: UrlSegment[]): boolean {
    const context = this.executionContext.getAuthenticated();
    // Sin sesión dejamos que AuthGuard se encargue de redirigir a login.
    if (!context) return true;

    const allowedProfiles = (route.data?.['allowedProfiles'] ?? []) as AuthenticatedProfileId[];
    // Las rutas exactas pueden desactivar el fallback de operadores. Las rutas
    // legacy sin esta marca siguen alcanzando AuthGuard para ser redirigidas a
    // la ruta inicial del perfil.
    const allowOperatorFallback = route.data?.['allowOperatorFallback'] !== false;
    return (
      allowedProfiles.includes(context.profileId) ||
      (allowOperatorFallback && context.role === 'operador-planta')
    );
  }
}
